<div class="legend-container" *ngIf="currentSelectedData">
  <div class="single-legend-element" [ngClass]="{'compareMode' : compareMode}" *ngFor="let element of currentSelectedData">
    <span class="colorDot {{element.name}}" [ngClass]="{'compareMode' : compareMode}"></span>
    <h4>
      {{ ('view_translations.' + element.translation) | translate | titlecase}}
      <span *ngIf="compareMode">({{ 'view_translations.period_' + currentPeriod | translate }})</span>
    </h4>
    <span *ngIf="compareMode" class="colorDot compare {{element.name}}" [ngClass]="{'compareMode' : compareMode}"></span>
    <h4 *ngIf="compareMode">
      {{ ('view_translations.' + element.translation) | translate | titlecase}} <span>({{ 'view_translations.period_' + comparePeriod | translate }})</span>
    </h4>
  </div>
</div>
